




import enterpriseTemplate from "./templates/enterpriseTemplate.vue";
import doctorTemplate from "./templates/doctorTemplate.vue";
export default {
  name: "aiwen-findPassword-pc",
  components: {
    enterpriseTemplate,
    doctorTemplate
  },
  computed: {
    currentComponent() {
      console.log((this as any).$attrs, "this.$attrs init");
      interface IbusinessTypeObj {
        [propName: string]: any;
      }
      const businessTypeObj: IbusinessTypeObj = {
        doctor: "doctorTemplate",
        biz: "enterpriseTemplate"
      };
      return businessTypeObj[(this as any).$attrs.config.businessType];
    }
  }
};
